var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container detail",domProps:{"innerHTML":_vm._s(_vm.language=== 'en' ? _vm.datas.enContent : _vm.language=== 'ru' ? _vm.datas.enContent : _vm.datas.content)}})
}
var staticRenderFns = []

export { render, staticRenderFns }